import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";

export const getLectureVideo = createAsyncThunk(
  "get/lectureVideo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("chapterVideosList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);

export const addLectureVideo = createAsyncThunk(
  "add/lecturevideo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("addChapterVideos", payload);
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const editLectureVideo = createAsyncThunk(
  "edit/lecturevideo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put("editChapterVideos", payload);
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const deleteLectureVideo = createAsyncThunk(
  "edit/lecturevideo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        "statusChangedChapterVideos",
        payload
      );
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const publishLectureVideo = createAsyncThunk(
  "publish/lecturevideo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("publishAllVideos", payload);
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const discardLectureVideo = createAsyncThunk(
  "discard/lecturevideo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("discardAllVideos", payload);
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
const lectureVideoManagement = createSlice({
  name: "lectureVideoManagement",
  initialState: {
    lectureVideo: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getLectureVideo.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getLectureVideo.fulfilled, (state, action) => {
      state.loading = false;
      state.lectureVideo = action.payload;
    });
    builder.addCase(getLectureVideo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
  },
});

export default lectureVideoManagement.reducer;
